import { Result } from "antd";
import { Navigate, Route, Routes } from "react-router-dom";
import { ConsoleLayout } from "@/layouts/ConsoleLayout";
import { RoutePage } from "@/router/RoutePage";
import { consoleRoutes, domainRedirects } from "@/router/routes";
import { ComponentShowcase } from "@/components/common/ComponentShowcase";

function StatusPage({ status, title }: { status: "403" | "404" | "500"; title: string }) {
    return <Result status={status} title={status} subTitle={title} />;
}

/** 64 个旧业务路径统一登记在布局下，后续页面任务只替换对应 element。 */
export default function App() {
    return <Routes>
        <Route path="/" element={<Navigate replace to="/logistics" />} />
        {Object.entries(domainRedirects).map(([path, target]) => <Route key={path} path={path} element={<Navigate replace to={target} />} />)}
        <Route element={<ConsoleLayout />}>
            {import.meta.env.DEV ? <Route path="/__migration/components" element={<ComponentShowcase />} /> : null}
            {consoleRoutes.map((route) => <Route key={route.name} path={route.path} element={<RoutePage route={route} />} />)}
            <Route path="/403" element={<StatusPage status="403" title="无权访问该页面" />} />
            <Route path="/500" element={<StatusPage status="500" title="网络或服务异常" />} />
        </Route>
        <Route path="/404" element={<StatusPage status="404" title="页面不存在" />} />
        <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>;
}
